import reportApi from './report-api';

export default reportApi;
